import React, { useEffect, useState } from "react";
import { Box, Collapse, Flex, Link, Text } from "@chakra-ui/react";

type TTableContent = {
  field: string;
  input: any;
};

type THelp = {
  text: string;
  url: string;
};

type TCollapsibleInformation = {
  title: string;
  table: Array<TTableContent>;
  itemName: string | undefined;
  help?: THelp;
  optional?: boolean;
  collapse?: boolean;
  shouldOpen?: boolean;
};

const CollapsibleInformation = ({
  title,
  table,
  itemName,
  help,
  optional,
  collapse,
  shouldOpen,
}: TCollapsibleInformation) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (shouldOpen) {
      setShow(true);
    }
  }, [shouldOpen]);

  useEffect(() => {
    if (collapse) {
      setShow(true);
    }
  }, [collapse]);

  const handleToggle = () => setShow(!show);

  return (
    <Flex
      justifyContent="flex-start"
      flexDirection="column"
      alignItems="flex-start"
      mt="36px"
    >
      <Text cursor="pointer" onClick={handleToggle} fontSize="16px">
        {show ? "-" : "+"} {title}
      </Text>
      <Collapse in={show} key={`${itemName}-collapse`}>
        <Box mt="4" p="4" backgroundColor="brand.900">
          <Text mt="0.5em">{itemName}</Text>
          <table className="fixedTable">
            <thead>
              <tr>
                <th className="fixedTd">Text Field</th>
                <th className="fixedTd">Input</th>
              </tr>
            </thead>
            <tbody>
              {table &&
                table.map((item, index) => (
                  <tr key={`${index}-table-content`}>
                    <td className="fixedTd">{item.field}</td>
                    <td className="fixedTd">{item.input}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {optional && (
            <Text fontSize="16px">
              * These fields are optional but recommended.
            </Text>
          )}
          <Text mt="1em" mb="1em">
            See wallet FAQs for additional help.
          </Text>
          {help && (
            <Link href={help.url} isExternal color="brand.300">
              {help.text}
            </Link>
          )}
        </Box>
      </Collapse>
    </Flex>
  );
};

export default CollapsibleInformation;
